var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9628C0 7.14419 7.14419 0 15.9628 0C24.7814 0 31.9256 7.14419 31.9256 15.9628C31.9256 24.7814 24.7814 31.9256 15.9628 31.9256C7.14419 31.907 0 24.7628 0 15.9628Z",
    fill: "#5865F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1441 9.46981C21.7859 8.85585 20.372 8.40934 18.9022 8.16748C18.7162 8.50236 18.5115 8.93027 18.3627 9.28376C16.7999 9.0419 15.2185 9.0419 13.6557 9.28376C13.4883 8.89306 13.3022 8.52097 13.0976 8.16748C11.6278 8.40934 10.1952 8.85585 8.8557 9.48841C6.17663 13.4884 5.45105 17.3768 5.80454 21.2279C7.38593 22.4 9.13477 23.2931 11.0138 23.8512C11.4417 23.2745 11.8138 22.6791 12.1301 22.0465C11.5162 21.8233 10.9394 21.5442 10.3813 21.2093C10.5301 21.0977 10.6604 20.9861 10.8092 20.8745C14.1022 22.4372 17.9348 22.4372 21.2278 20.8745C21.3766 20.9861 21.5069 21.0977 21.6557 21.2093C21.0976 21.5442 20.5022 21.8233 19.8883 22.0465C20.2045 22.6791 20.5766 23.2745 21.0045 23.8512C22.8836 23.2745 24.651 22.4 26.2138 21.2279C26.6231 16.7628 25.4697 12.8931 23.1441 9.46981ZM12.5766 18.8466C11.5534 18.8466 10.7348 17.9163 10.7348 16.7814C10.7348 15.6465 11.5534 14.6977 12.5766 14.6977C13.6185 14.6977 14.4371 15.6279 14.4371 16.7814C14.4185 17.9163 13.6185 18.8466 12.5766 18.8466ZM19.4231 18.8466C18.3999 18.8466 17.5813 17.9163 17.5813 16.7814C17.5813 15.6465 18.3999 14.6977 19.4231 14.6977C20.465 14.6977 21.2836 15.6279 21.265 16.7814C21.2464 17.9349 20.4464 18.8466 19.4231 18.8466Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord_logo.6a8883a193fc40c3aa267b617f74a17e.svg";
export { ForwardRef as ReactComponent };